import type { FlaggedIntention, FlaggedPromptResponse } from "@packages/sdk";
import { FlaggableType } from "@packages/sdk";
import type { HTMLAttributes } from "react";

import {
  ReportedCardIntention,
  ReportedCardPromptResponse,
} from "./reportedCards";

type ReportedCardProps = Omit<HTMLAttributes<HTMLDivElement>, "children"> & {
  data: FlaggedIntention | FlaggedPromptResponse;
  type: FlaggableType;
};

export const ReportedCard = ({ data, type, ...props }: ReportedCardProps) => {
  switch (type) {
    case FlaggableType.Intention:
      return (
        <ReportedCardIntention data={data as FlaggedIntention} {...props} />
      );
    case FlaggableType.PromptResponse:
      return (
        <ReportedCardPromptResponse
          data={data as FlaggedPromptResponse}
          {...props}
        />
      );
    default:
      return null;
  }
};

ReportedCard.displayName = "ReportedCard";
